// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"CategoryFilters_filterContainer__342GG","active":"CategoryFilters_active__2InRe"};